import styled from 'styled-components';
import { scarpaGray50 } from '@habitech/shared';

export const Container = styled.div`
    position: fixed;
    z-index: 1000;
    top: 0px;
    left: 0px;
    width: 100%;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.8s ease 0s;
`;

export const ModalBody = styled.div`
    width: 450px;
    background-color: white;
    border: 1px solid ${scarpaGray50};
    border-radius: 8px;
    margin: auto;
    padding: 16px;
    position: relative;
    .pcom-icon-close {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        z-index: 1;
    }
`;
